// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sa4A_","rootMobile":"styles_rootMobile__2JR2y"};